import { Pill } from '@/components/ui/pill';
import { fmtBRL } from '@/lib/utils';
import type { PrestStatus } from './types';
import { HERO_COPY } from './types';

const STATUS_PILL_TONE = {
  pronta: 'info',
  concluida: 'pass',
  rascunho: 'default',
} as const;

const STATUS_LABEL = {
  pronta: 'pronta',
  concluida: 'concluída',
  rascunho: 'rascunho',
} as const;

interface HomeHeroCardProps {
  prestStatus: PrestStatus;
  lancamentosCount: number;
  valorTotal: number;
  monthIndex: number;
  year: number;
}

/**
 * Hero card adaptativo da Home mobile.
 * Cor/copy variam conforme o status da prestação do mês selecionado.
 */
export function HomeHeroCard({
  prestStatus,
  lancamentosCount,
  valorTotal,
  monthIndex,
  year,
}: HomeHeroCardProps) {
  const copy = HERO_COPY[prestStatus];
  const mesLabel = String(monthIndex + 1).padStart(2, '0');
  const eyebrow = `Prestação ${mesLabel}/${year}`;

  return (
    <div
      style={{
        padding: '20px 20px 22px',
        borderRadius: 'var(--r-4)',
        background: 'linear-gradient(160deg, var(--mint-soft) 0%, var(--mint) 70%)',
        boxShadow: 'var(--shadow-clay-mint)',
        border: '1px solid rgba(255,255,255,0.45)',
      }}
    >
      {/* Eyebrow + Pill status */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 4,
        }}
      >
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            letterSpacing: '0.10em',
            textTransform: 'uppercase',
            fontWeight: 600,
            color: 'var(--on-mint)',
            opacity: 0.8,
          }}
        >
          {eyebrow}
        </span>
        <Pill tone={STATUS_PILL_TONE[prestStatus]} dot>
          {STATUS_LABEL[prestStatus]}
        </Pill>
      </div>

      {/* Título copy adaptativo */}
      <h2
        style={{
          fontWeight: 700,
          color: 'var(--on-mint)',
          textAlign: 'left',
          lineHeight: 1.1,
          letterSpacing: '-0.035em',
          fontSize: 20,
          margin: '2px 0 8px',
          fontFamily: 'var(--font-display)',
        }}
      >
        {copy.titleLine1} {copy.titleLine2}
      </h2>

      {/* Linha mono: contagem + valor (tabular nums) */}
      <div
        style={{
          fontSize: 12.5,
          opacity: 0.82,
          fontFamily: 'var(--font-mono)',
          color: 'var(--on-mint)',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {lancamentosCount > 0
          ? `${lancamentosCount} lançamentos · ${fmtBRL(valorTotal)}`
          : 'nenhum lançamento ainda'}
      </div>
    </div>
  );
}
